module.exports = __webpack_public_path__ + "img/60.7886ff01.jpg";